import WowFIlter from "@/pages/dashboard/filterPageComponents/wow/wowFIlter";
import CreatorProfile from "@/pages/dashboard/pages/wow/components/CreatorProfile";
import CreatorProfileService from "@/pages/dashboard/pages/wow/components/CreatorProfileService";
// 新进用户渠道构成
import WowNewUserChannleService from '@/pages/dashboard/pages/wow/components/NewUserChannleService';
// 日活构成 
import WowNewUserService from '@/pages/dashboard/pages/wow/components/NewUserService';
// 地图
import WowMapService from '@/pages/dashboard/pages/wow/components/MapService';
import PlayLevelService from "@/pages/dashboard/pages/wow/components/PlayLevelService";


export default {
  WowFIlter,
  CreatorProfileService,
  CreatorProfile,
  WowNewUserChannleService,
  WowNewUserService,
  WowMapService,
  PlayLevelService
};